webpackJsonp([1],{

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var redoodle_1 = __webpack_require__(8);
var Actions = __webpack_require__(39);
var loading_1 = __webpack_require__(112);
var error_1 = __webpack_require__(42);
var notesService_1 = __webpack_require__(113);
var auth_1 = __webpack_require__(41);
exports.loadNotes = function () { return function (dispatch) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var notes, e_1;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(loading_1.StartLoading.create());
                return [4, auth_1.refreshToken(dispatch)];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, , 5]);
                return [4, notesService_1.NotesServiceProvider.get().getNotes()];
            case 3:
                notes = _a.sent();
                dispatch(redoodle_1.CompoundAction.create([
                    Actions.NotesLoaded.create({ notes: notes }),
                    loading_1.StopLoading.create(),
                ]));
                return [3, 5];
            case 4:
                e_1 = _a.sent();
                handleError(dispatch, 'Error loading notes. Please try again later.', e_1);
                return [3, 5];
            case 5: return [2];
        }
    });
}); }; };
exports.addNote = function () { return function (dispatch) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var noteId, e_2;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(loading_1.StartLoading.create());
                return [4, auth_1.refreshToken(dispatch)];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, , 5]);
                return [4, notesService_1.NotesServiceProvider.get().createNote()];
            case 3:
                noteId = _a.sent();
                dispatch(redoodle_1.CompoundAction.create([
                    loading_1.StopLoading.create(),
                    Actions.NoteAdded.create({ noteId: noteId }),
                    Actions.NoteSelected.create({ noteId: noteId }),
                ]));
                return [3, 5];
            case 4:
                e_2 = _a.sent();
                handleError(dispatch, 'Error creating a new note.', e_2);
                return [3, 5];
            case 5: return [2];
        }
    });
}); }; };
exports.deleteNote = function (noteId) { return function (dispatch) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var e_3;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(loading_1.StartLoading.create());
                return [4, auth_1.refreshToken(dispatch)];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, , 5]);
                return [4, notesService_1.NotesServiceProvider.get().deleteNote(noteId)];
            case 3:
                _a.sent();
                dispatch(redoodle_1.CompoundAction.create([
                    loading_1.StopLoading.create(),
                    Actions.NoteDeleted.create({ noteId: noteId }),
                ]));
                return [3, 5];
            case 4:
                e_3 = _a.sent();
                handleError(dispatch, 'Error deleting note.', e_3);
                return [3, 5];
            case 5: return [2];
        }
    });
}); }; };
exports.saveNote = function (noteId, content) { return function (dispatch) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var e_4;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(loading_1.StartLoading.create());
                return [4, auth_1.refreshToken(dispatch)];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, , 5]);
                return [4, notesService_1.NotesServiceProvider.get().updateNote(noteId, content)];
            case 3:
                _a.sent();
                dispatch(redoodle_1.CompoundAction.create([
                    loading_1.StopLoading.create(),
                    Actions.NoteSaved.create({ noteId: noteId, content: content }),
                ]));
                return [3, 5];
            case 4:
                e_4 = _a.sent();
                handleError(dispatch, 'Error saving note.', e_4);
                return [3, 5];
            case 5: return [2];
        }
    });
}); }; };
var handleError = function (dispatch, message, error) {
    dispatch(redoodle_1.CompoundAction.create([
        loading_1.StopLoading.create(),
        error_1.ShowError.create({ message: message, error: error }),
    ]));
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/store/actions/notesAsync.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/store/actions/notesAsync.ts"); } } })();

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var redoodle_1 = __webpack_require__(8);
exports.StartLoading = redoodle_1.TypedAction.defineWithoutPayload('START_LOADING')();
exports.StopLoading = redoodle_1.TypedAction.defineWithoutPayload('STOP_LOADING')();


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/store/actions/loading.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/store/actions/loading.ts"); } } })();

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var service_1 = __webpack_require__(269);
var HttpClientImpl = (function () {
    function HttpClientImpl(headers) {
        this.headers = headers;
    }
    HttpClientImpl.prototype.request = function (requestConfig) {
        var config = {
            method: requestConfig.method,
            headers: this.headers,
            body: JSON.stringify(requestConfig.data),
        };
        return fetch("api/" + requestConfig.url, config)
            .then(function (response) {
            if (!response.ok) {
                throw new Error(response.statusText);
            }
            if (response.status === 204) {
                return null;
            }
            return response.json();
        });
    };
    return HttpClientImpl;
}());
var NotesService = (function () {
    function NotesService(apiToken) {
        this.apiToken = apiToken;
        var httpClient = new HttpClientImpl(this.getHeaders());
        this.notesServiceClient = new service_1.RestApplicationClient(httpClient);
    }
    NotesService.prototype.createNote = function () {
        return this.notesServiceClient.createNote()
            .then(function (noteId) { return noteId.noteId; });
    };
    NotesService.prototype.deleteNote = function (noteId) {
        return this.notesServiceClient.deleteNote(noteId);
    };
    NotesService.prototype.getNotes = function () {
        return this.notesServiceClient.getNotes()
            .then(function (notes) { return notes.map(function (note) { return ({
            id: note.id,
            content: note.content,
            modified: new Date(note.modified),
            created: new Date(note.created),
        }); }); });
    };
    NotesService.prototype.updateNote = function (noteId, content) {
        return this.notesServiceClient.updateNote(noteId, { content: content });
    };
    NotesService.prototype.getHeaders = function () {
        var headers = new Headers();
        headers.append('Authorization', "Bearer " + this.apiToken);
        headers.append('Content-Type', 'Application/json');
        return headers;
    };
    return NotesService;
}());
var NotesServiceProvider = (function () {
    function NotesServiceProvider() {
    }
    NotesServiceProvider.get = function () {
        if (!NotesServiceProvider.notesService) {
            if (!NotesServiceProvider.authToken) {
                throw new Error('Auth token not set');
            }
            NotesServiceProvider.notesService = new NotesService(NotesServiceProvider.authToken);
        }
        return NotesServiceProvider.notesService;
    };
    NotesServiceProvider.setAuthToken = function (authToken) {
        NotesServiceProvider.authToken = authToken;
        NotesServiceProvider.notesService = new NotesService(authToken);
    };
    NotesServiceProvider.clearAuthToken = function () {
        NotesServiceProvider.authToken = null;
        NotesServiceProvider.notesService = null;
    };
    NotesServiceProvider.notesService = null;
    NotesServiceProvider.authToken = null;
    return NotesServiceProvider;
}());
exports.NotesServiceProvider = NotesServiceProvider;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/service/notesService.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/service/notesService.ts"); } } })();

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var redoodle_1 = __webpack_require__(8);
exports.SearchChanged = redoodle_1.TypedAction.define('SEARCH_CHANGED')();


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/store/actions/search.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/store/actions/search.ts"); } } })();

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(121);
module.exports = __webpack_require__(124);


/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(43);
var react_hot_loader_1 = __webpack_require__(215);
var appProvider_1 = __webpack_require__(220);
__webpack_require__(596);
var renderRoot = function (app) {
    ReactDOM.render(app, document.getElementById('rootApp'));
};
var renderDev = function (Component) {
    renderRoot(React.createElement(react_hot_loader_1.AppContainer, null,
        React.createElement(Component, null)));
};
var init = function () {
    if (true) {
        renderRoot(React.createElement(appProvider_1.AppProvider, null));
    }
    else {
        renderDev(appProvider_1.AppProvider);
        if (module.hot) {
            module.hot.accept('./appProvider', function () { return renderDev(appProvider_1.AppProvider); });
        }
    }
};
init();


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/index.tsx"); } } })();

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(38);
var store_1 = __webpack_require__(248);
var App_1 = __webpack_require__(273);
var auth_1 = __webpack_require__(41);
var store = store_1.configureStore();
window.onload = function () { return gapi.load('auth2', function () { return store.dispatch(auth_1.initAuth()); }); };
exports.AppProvider = function () {
    return (React.createElement(react_redux_1.Provider, { store: store },
        React.createElement(App_1.default, null)));
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/appProvider.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/appProvider.tsx"); } } })();

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var redoodle_1 = __webpack_require__(8);
var redux_1 = __webpack_require__(101);
var redux_thunk_1 = __webpack_require__(264);
var reducers_1 = __webpack_require__(265);
function configureStore() {
    return redoodle_1.createStore(redoodle_1.reduceCompoundActions(reducers_1.RootReducer), reducers_1.initialState, redux_1.compose(redux_1.applyMiddleware(redux_thunk_1.default, redoodle_1.loggingMiddleware({ enableInProduction: false }))));
}
exports.configureStore = configureStore;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/store/index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/store/index.ts"); } } })();

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var redoodle_1 = __webpack_require__(8);
var notes_1 = __webpack_require__(266);
var selectedNote_1 = __webpack_require__(267);
var account_1 = __webpack_require__(268);
var search_1 = __webpack_require__(270);
var loading_1 = __webpack_require__(271);
var error_1 = __webpack_require__(272);
exports.RootReducer = redoodle_1.combineReducers({
    notes: notes_1.Reducer,
    selectedNote: selectedNote_1.Reducer,
    account: account_1.Reducer,
    search: search_1.Reducer,
    loading: loading_1.Reducer,
    error: error_1.Reducer,
});
exports.initialState = {
    notes: [],
    selectedNote: { id: 'null' },
    account: { loggedIn: true, idToken: null },
    search: { term: '' },
    loading: false,
    error: { visible: false, message: null },
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/store/reducers/index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/store/reducers/index.ts"); } } })();

/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var redoodle_1 = __webpack_require__(8);
var Actions = __webpack_require__(39);
var utils_1 = __webpack_require__(40);
function createReducer() {
    var builder = redoodle_1.TypedReducer.builder();
    builder.withHandler(Actions.NotesLoaded.TYPE, function (state, payload) {
        return utils_1.sortNotes(payload.notes);
    });
    builder.withHandler(Actions.NoteAdded.TYPE, function (state, payload) {
        return utils_1.sortNotes([
            {
                id: payload.noteId,
                content: '',
                created: new Date(),
                modified: new Date(),
            }
        ].concat(state));
    });
    builder.withHandler(Actions.NoteDeleted.TYPE, function (state, payload) {
        return state.filter(function (note) { return note.id !== payload.noteId; });
    });
    builder.withHandler(Actions.NoteSaved.TYPE, function (state, payload) {
        return utils_1.sortNotes(state.map(function (note) {
            if (note.id !== payload.noteId) {
                return note;
            }
            return redoodle_1.setWith(note, { content: payload.content, modified: new Date() });
        }));
    });
    return builder.build();
}
exports.Reducer = createReducer();


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/store/reducers/notes.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/store/reducers/notes.ts"); } } })();

/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var redoodle_1 = __webpack_require__(8);
var Actions = __webpack_require__(39);
var utils_1 = __webpack_require__(40);
function createReducer() {
    return redoodle_1.TypedReducer.builder()
        .withHandler(Actions.NotesLoaded.TYPE, function (state, payload) {
        if (payload.notes.length === 0) {
            return { id: null };
        }
        return { id: utils_1.sortNotes(payload.notes)[0].id };
    })
        .withHandler(Actions.NoteSelected.TYPE, function (state, payload) {
        return { id: payload.noteId };
    })
        .build();
}
exports.Reducer = createReducer();


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/store/reducers/selectedNote.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/store/reducers/selectedNote.ts"); } } })();

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var redoodle_1 = __webpack_require__(8);
var Actions = __webpack_require__(41);
var notesService_1 = __webpack_require__(113);
function createReducer() {
    return redoodle_1.TypedReducer.builder()
        .withHandler(Actions.SignedIn.TYPE, function (state, payload) {
        notesService_1.NotesServiceProvider.setAuthToken(payload.idToken);
        return { loggedIn: true, idToken: payload.idToken };
    })
        .withHandler(Actions.SignedOut.TYPE, function () {
        notesService_1.NotesServiceProvider.clearAuthToken();
        return { loggedIn: false, idToken: null };
    })
        .build();
}
exports.Reducer = createReducer();


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/store/reducers/account.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/store/reducers/account.ts"); } } })();

/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RestApplicationClient = (function () {
    function RestApplicationClient(httpClient) {
        this.httpClient = httpClient;
    }
    RestApplicationClient.prototype.createNote = function () {
        return this.httpClient.request({ method: "POST", url: (_a = ["notes"], _a.raw = ["notes"], uriEncoding(_a)) });
        var _a;
    };
    RestApplicationClient.prototype.deleteNote = function (noteId) {
        return this.httpClient.request({ method: "DELETE", url: (_a = ["notes/", ""], _a.raw = ["notes/", ""], uriEncoding(_a, noteId)) });
        var _a;
    };
    RestApplicationClient.prototype.getNotes = function () {
        return this.httpClient.request({ method: "GET", url: (_a = ["notes"], _a.raw = ["notes"], uriEncoding(_a)) });
        var _a;
    };
    RestApplicationClient.prototype.updateNote = function (noteId, arg2) {
        return this.httpClient.request({ method: "PUT", url: (_a = ["notes/", ""], _a.raw = ["notes/", ""], uriEncoding(_a, noteId)), data: arg2 });
        var _a;
    };
    return RestApplicationClient;
}());
exports.RestApplicationClient = RestApplicationClient;
function uriEncoding(template) {
    var substitutions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        substitutions[_i - 1] = arguments[_i];
    }
    var result = "";
    for (var i = 0; i < substitutions.length; i++) {
        result += template[i];
        result += encodeURIComponent(substitutions[i]);
    }
    result += template[template.length - 1];
    return result;
}


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/_generated/service.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/_generated/service.ts"); } } })();

/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var redoodle_1 = __webpack_require__(8);
var Actions = __webpack_require__(114);
function createReducer() {
    return redoodle_1.TypedReducer.builder()
        .withHandler(Actions.SearchChanged.TYPE, function (state, payload) {
        return { term: payload.term };
    })
        .build();
}
exports.Reducer = createReducer();


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/store/reducers/search.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/store/reducers/search.ts"); } } })();

/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var redoodle_1 = __webpack_require__(8);
var Actions = __webpack_require__(112);
function createReducer() {
    return redoodle_1.TypedReducer.builder()
        .withHandler(Actions.StartLoading.TYPE, function () {
        return true;
    })
        .withHandler(Actions.StopLoading.TYPE, function () {
        return false;
    })
        .build();
}
exports.Reducer = createReducer();


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/store/reducers/loading.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/store/reducers/loading.ts"); } } })();

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var redoodle_1 = __webpack_require__(8);
var Actions = __webpack_require__(42);
var ISSUES_URL = 'https://github.com/fawind/notes/issues/new';
function logError(message, error) {
    console.error("Error: \"" + message + "\". If the error persists, please open an issue: " + ISSUES_URL);
    if (error) {
        console.error(error);
    }
}
function createReducer() {
    return redoodle_1.TypedReducer.builder()
        .withHandler(Actions.ShowError.TYPE, function (state, payload) {
        logError(payload.message, payload.error);
        return { visible: true, message: payload.message };
    })
        .withHandler(Actions.HideError.TYPE, function () {
        return { visible: false, message: null };
    })
        .build();
}
exports.Reducer = createReducer();


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/store/reducers/error.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/store/reducers/error.ts"); } } })();

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(38);
var NoteApp_1 = __webpack_require__(274);
var SignInPage_1 = __webpack_require__(582);
var LoadingBar_1 = __webpack_require__(589);
var ErrorNotifier_1 = __webpack_require__(592);
var getAppOrSignIn = function (loggedIn) {
    if (loggedIn) {
        return React.createElement(NoteApp_1.default, null);
    }
    return React.createElement(SignInPage_1.default, null);
};
var getLoadingBar = function (loading) {
    if (loading) {
        return React.createElement(LoadingBar_1.LoadingBar, null);
    }
    return null;
};
var App = function (props) {
    return (React.createElement("div", null,
        React.createElement(ErrorNotifier_1.default, null),
        getLoadingBar(props.loading),
        getAppOrSignIn(props.loggedIn)));
};
var mapStateToProps = function (state) { return ({
    loggedIn: state.account.loggedIn,
    loading: state.loading,
    hasError: state.error.visible,
    errorMessage: state.error.message,
}); };
exports.default = react_redux_1.connect(mapStateToProps)(App);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/containers/App.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/containers/App.tsx"); } } })();

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var SplitPane = __webpack_require__(275);
var react_redux_1 = __webpack_require__(38);
var SideBar_1 = __webpack_require__(311);
var NoteEditor_1 = __webpack_require__(564);
var NoteActions = __webpack_require__(111);
var SearchActions = __webpack_require__(114);
var notes_1 = __webpack_require__(39);
var selectors_1 = __webpack_require__(580);
var NoteApp = function (props) {
    if (!props.selectedNote) {
        return (React.createElement(SplitPane, { split: 'vertical', minSize: 100, defaultSize: 200 },
            React.createElement(SideBar_1.SideBar, { notes: props.notes, selectNote: props.selectNote, selectedNoteId: null, addNote: props.addNote, deleteNote: props.deleteNote, searchChanged: props.searchChanged }),
            React.createElement("div", null)));
    }
    return (React.createElement(SplitPane, { split: 'vertical', minSize: 100, defaultSize: 250 },
        React.createElement(SideBar_1.SideBar, { notes: props.notes, selectNote: props.selectNote, selectedNoteId: props.selectedNote.id, addNote: props.addNote, deleteNote: props.deleteNote, searchChanged: props.searchChanged }),
        React.createElement(NoteEditor_1.NoteEditor, { note: props.selectedNote, saveNote: props.saveNote })));
};
var mapStateToProps = function (state) { return ({
    notes: selectors_1.getFilteredNotes(state),
    selectedNote: selectors_1.getSelectedNote(state),
}); };
var mapDispatchToProps = function (dispatch) {
    return {
        addNote: function () { return dispatch(NoteActions.addNote()); },
        deleteNote: function (noteId) { return dispatch(NoteActions.deleteNote(noteId)); },
        saveNote: function (noteId, content) { return dispatch(NoteActions.saveNote(noteId, content)); },
        selectNote: function (noteId) { return dispatch(notes_1.NoteSelected.create({ noteId: noteId })); },
        searchChanged: function (term) { return dispatch(SearchActions.SearchChanged.create({ term: term })); },
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(NoteApp);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/containers/NoteApp.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/containers/NoteApp.tsx"); } } })();

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var FlipMove = __webpack_require__(312);
var SideBarItem_1 = __webpack_require__(319);
var ActionBar_1 = __webpack_require__(560);
__webpack_require__(561);
var isSelected = function (noteId, selectedId) {
    return noteId === selectedId;
};
exports.SideBar = function (props) {
    return (React.createElement("div", { className: 'sidebar' },
        React.createElement(ActionBar_1.ActionBar, { onCreate: props.addNote, onSearch: props.searchChanged }),
        React.createElement(FlipMove, { className: 'itemList' }, props.notes.map(function (note) { return (React.createElement(SideBarItem_1.SideBarItem, { key: note.id, id: note.id, content: note.content, modified: note.modified, selected: isSelected(note.id, props.selectedNoteId), onSelect: props.selectNote, onDelete: props.deleteNote })); }))));
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/components/SideBar/index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/components/SideBar/index.tsx"); } } })();

/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(0);
var react_feather_1 = __webpack_require__(119);
var utils_1 = __webpack_require__(40);
var SPLIT_TOKEN = '\n';
var PLACEHOLDER_TITLE = 'New Note';
var PLACEHOLDER_BODY = 'Write something';
var getNoteTitle = function (content) {
    if (content.length === 0) {
        return PLACEHOLDER_TITLE;
    }
    return content.split(SPLIT_TOKEN)[0].replace('#', '').trim();
};
var getNoteBody = function (content) {
    var parts = content.split(SPLIT_TOKEN);
    if (parts.length === 1) {
        return PLACEHOLDER_BODY;
    }
    return parts.slice(1).join(' ').substring(0, 100).trim();
};
var SideBarItem = (function (_super) {
    tslib_1.__extends(SideBarItem, _super);
    function SideBarItem(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSelect = _this.handleSelect.bind(_this);
        _this.handleDelete = _this.handleDelete.bind(_this);
        return _this;
    }
    SideBarItem.prototype.handleSelect = function () {
        this.props.onSelect(this.props.id);
    };
    SideBarItem.prototype.handleDelete = function () {
        this.props.onDelete(this.props.id);
    };
    SideBarItem.prototype.render = function () {
        return (React.createElement("div", { className: "item " + (this.props.selected ? 'selected' : ''), onClick: this.handleSelect },
            React.createElement("div", { className: 'title' },
                getNoteTitle(this.props.content),
                this.props.selected && React.createElement("a", { className: 'delete', onClick: this.handleDelete },
                    React.createElement(react_feather_1.X, null))),
            React.createElement("div", { className: 'date' }, utils_1.getTimeSince(this.props.modified)),
            React.createElement("div", { className: 'body' }, getNoteBody(this.props.content))));
    };
    return SideBarItem;
}(React.PureComponent));
exports.SideBarItem = SideBarItem;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/components/SideBar/SideBarItem.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/components/SideBar/SideBarItem.tsx"); } } })();

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var redoodle_1 = __webpack_require__(8);
exports.NotesLoaded = redoodle_1.TypedAction.define('NOTES_LOADED')();
exports.NoteAdded = redoodle_1.TypedAction.define('NOTE_ADDED')();
exports.NoteDeleted = redoodle_1.TypedAction.define('NOTE_DELETED')();
exports.NoteSaved = redoodle_1.TypedAction.define('NOTE_SAVED')();
exports.NoteSelected = redoodle_1.TypedAction.define('NOTE_SELECTED')();


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/store/actions/notes.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/store/actions/notes.ts"); } } })();

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.sortNotes = function (notes) {
    if (notes.length <= 1) {
        return notes;
    }
    return notes.sort(function (noteA, noteB) {
        return noteB.modified.getTime() - noteA.modified.getTime();
    });
};
exports.markdownModifierOverlay = function () {
    var MODIFIER_CLASS = 'mod';
    var HEADING_RE = /(#{1,6})(?:\s)/;
    var LIST_RE = /^\s*(-\s\[(x|\s)]|\*|-|\+|\d+\.)\s/;
    var QUOTE_RE = /^>(?:\s)/;
    var getClass = function (optionalClass) {
        if (!optionalClass) {
            return MODIFIER_CLASS;
        }
        return MODIFIER_CLASS + " " + MODIFIER_CLASS + "-" + optionalClass;
    };
    return {
        token: function (stream) {
            if (stream.sol() && stream.match(HEADING_RE)) {
                return getClass('header');
            }
            else if (stream.sol() && stream.match(LIST_RE)) {
                return getClass('list');
            }
            else if (stream.sol() && stream.match(QUOTE_RE)) {
                return getClass();
            }
            stream.next();
            return;
        },
    };
};
exports.getTimeSince = function (date) {
    var diff = Math.abs((new Date().getTime() - date.getTime()) / 1000);
    var dayDiff = Math.floor(diff / 86400);
    if (dayDiff === 0) {
        if (diff < 60) {
            return 'Just now';
        }
        if (diff < 120) {
            return '1 minute ago';
        }
        if (diff < 3600) {
            return Math.floor(diff / 60) + " minutes ago";
        }
        if (diff < 7200) {
            return '1 hour ago';
        }
        if (diff < 86400) {
            return Math.floor(diff / 3600) + " hours ago";
        }
    }
    if (dayDiff === 1) {
        return 'Yesterday';
    }
    if (dayDiff < 7) {
        return dayDiff + " days ago";
    }
    if (dayDiff < 31) {
        return Math.ceil(dayDiff / 7) + " weeks ago";
    }
    return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/utils/index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/utils/index.ts"); } } })();

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var redoodle_1 = __webpack_require__(8);
var notesAsync_1 = __webpack_require__(111);
var error_1 = __webpack_require__(42);
var CLIENT_ID = '998747770178-tsvdpds9s2kam1u57u67ltuj383f7p3s.apps.googleusercontent.com';
exports.SignedIn = redoodle_1.TypedAction.define('SIGNED_IN')();
exports.SignedOut = redoodle_1.TypedAction.defineWithoutPayload('SIGNED_OUT')();
exports.signIn = function () { return gapi.auth2.getAuthInstance().signIn(); };
exports.signOut = function () { return gapi.auth2.getAuthInstance().signOut(); };
exports.updateSignInStatus = function (isSignedIn, dispatch) {
    if (isSignedIn) {
        var idToken = gapi.auth2.getAuthInstance()
            .currentUser.get()
            .getAuthResponse().id_token;
        dispatch(exports.SignedIn.create({ idToken: idToken }));
        dispatch(notesAsync_1.loadNotes());
    }
    else {
        dispatch(exports.SignedOut.create());
    }
};
exports.initAuth = function () { return function (dispatch) {
    var initPromise = gapi.auth2.init({
        client_id: CLIENT_ID,
    });
    initPromise.then(function () {
        gapi.auth2.getAuthInstance()
            .isSignedIn
            .listen(function (newIsSignedIn) { return exports.updateSignInStatus(newIsSignedIn, dispatch); });
        var isSignedIn = gapi.auth2.getAuthInstance().isSignedIn.get();
        exports.updateSignInStatus(isSignedIn, dispatch);
    }, function (error) {
        var message = "Error loading app: " + (error.details || '');
        dispatch(error_1.ShowError.create({ message: message, error: error }));
    });
}; };
exports.isTokenExpired = function () {
    var EXPIRATION_OFFSET = 10 * 60 * 1000;
    var expiresAt = gapi.auth2.getAuthInstance()
        .currentUser.get().getAuthResponse().expires_at;
    return new Date() > new Date(expiresAt - EXPIRATION_OFFSET);
};
exports.refreshToken = function (dispatch) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!exports.isTokenExpired()) return [3, 2];
                return [4, gapi.auth2.getAuthInstance().currentUser.get().reloadAuthResponse()
                        .then(function (authResponse) { return dispatch(exports.SignedIn.create({ idToken: authResponse.id_token })); })];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [2];
        }
    });
}); };


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/store/actions/auth.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/store/actions/auth.ts"); } } })();

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var redoodle_1 = __webpack_require__(8);
exports.ShowError = redoodle_1.TypedAction.define('SHOW_ERROR')();
exports.HideError = redoodle_1.TypedAction.defineWithoutPayload('HIDE_ERROR')();


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/store/actions/error.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/store/actions/error.ts"); } } })();

/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_feather_1 = __webpack_require__(119);
exports.handleFocus = function (event) {
    event.target.select();
};
exports.ActionBar = function (props) {
    var handleCreate = function () { return props.onCreate(); };
    var handleSearchChange = function (event) {
        var text = event.target.value || '';
        props.onSearch(text);
    };
    return (React.createElement("div", { className: 'actionBar' },
        React.createElement("a", { className: 'icon', onClick: handleCreate },
            React.createElement(react_feather_1.Edit, null)),
        React.createElement("input", { type: 'search', className: 'searchBar', placeholder: 'Search Notes', onFocus: exports.handleFocus, onChange: handleSearchChange })));
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/components/SideBar/ActionBar.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/components/SideBar/ActionBar.tsx"); } } })();

/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(562);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(18)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!./styles.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!./styles.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(17)(undefined);
// imports


// module
exports.push([module.i, ".sidebar .itemList{overflow-y:auto;height:calc(100% - 53px)}.sidebar .itemList::-webkit-scrollbar{display:none}.sidebar .item{padding:10px 10px 20px 20px;border-bottom:1px solid #ddd;overflow:hidden;cursor:pointer;border-left:6px solid transparent;transition:border-color .2s ease-in}.sidebar .item:hover{background-color:#fff}.sidebar .item.selected{border-left:6px solid red;background-color:#fff}.sidebar .item .title{font-weight:700;font-size:1.1em}.sidebar .title .delete{float:right;color:#a3abb3;cursor:pointer;-webkit-transition:color .2s ease-in}.sidebar .title .delete:hover{color:red}.sidebar .item .date{color:#a3abb3}.sidebar .item .body{color:#a3abb3;height:2em;line-height:1.5em}.sidebar .actionBar{border-bottom:1px solid #ddd;display:table;border-spacing:10px;width:100%}.sidebar .actionBar .icon{display:table-cell;color:#a3abb3;cursor:pointer;-webkit-transition:color .2s ease-in}.sidebar .actionBar .icon:hover{color:inherit}.sidebar .actionBar input{display:table-cell;font-family:inherit;outline:none;font-size:100%;border:1px solid #ccc;border-radius:5px;color:#a3abb3;width:100%;padding-left:10px;padding-right:10px}.sidebar .actionBar input::-webkit-search-decoration,input::-webkit-search-cancel-button{display:none}", ""]);

// exports


/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(15);
var React = __webpack_require__(0);
var react_codemirror2_1 = __webpack_require__(565);
__webpack_require__(566);
__webpack_require__(567);
__webpack_require__(572);
__webpack_require__(576);
var utils_1 = __webpack_require__(40);
__webpack_require__(578);
var NoteEditor = (function (_super) {
    tslib_1.__extends(NoteEditor, _super);
    function NoteEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.saveTimeout = 5000;
        _this.editorOptions = {
            theme: 'paper',
            mode: { name: 'gfm', gitHubSpice: false },
            extraKeys: {
                'Enter': 'newlineAndIndentContinueMarkdownList',
                'Ctrl-S': _this.saveEditor.bind(_this),
            },
            lineWrapping: true,
        };
        _this.initializeEditor = _this.initializeEditor.bind(_this);
        _this.saveEditor = _this.saveEditor.bind(_this);
        return _this;
    }
    NoteEditor.prototype.shouldComponentUpdate = function (nextProps) {
        return this.props.note.id !== nextProps.note.id;
    };
    NoteEditor.prototype.componentWillUnmount = function () {
        clearTimeout(this.timeoutId);
    };
    NoteEditor.prototype.initializeEditor = function (editor, next) {
        editor.addOverlay(utils_1.markdownModifierOverlay());
        next();
        this.autosaveEditor(editor);
    };
    NoteEditor.prototype.autosaveEditor = function (editor) {
        var _this = this;
        if (!editor.isClean()) {
            this.saveEditor(editor)
                .then(function () {
                editor.markClean();
                _this.timeoutId = setTimeout(_this.autosaveEditor.bind(_this, editor), _this.saveTimeout);
            });
        }
        else {
            this.timeoutId = setTimeout(this.autosaveEditor.bind(this, editor), this.saveTimeout);
        }
    };
    NoteEditor.prototype.saveEditor = function (editor) {
        if (this.props.note.content === editor.getValue()) {
            return new Promise(function (resolve) { resolve(); });
        }
        return this.props.saveNote(this.props.note.id, editor.getValue());
    };
    NoteEditor.prototype.render = function () {
        return (React.createElement(react_codemirror2_1.default, { options: this.editorOptions, value: this.props.note.content, editorDidMount: this.initializeEditor }));
    };
    return NoteEditor;
}(React.PureComponent));
exports.NoteEditor = NoteEditor;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/components/NoteEditor/index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/components/NoteEditor/index.tsx"); } } })();

/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(579);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(18)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!./styles.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!./styles.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(17)(undefined);
// imports


// module
exports.push([module.i, ".CodeMirror,.react-codemirror2{position:relative;height:100%}.CodeMirror{font-family:Nunito,sans-serif;color:#444;background-color:#fbfbfb}.CodeMirror pre{padding-left:10%;padding-right:10%}.CodeMirror .cm-mod{color:red}.CodeMirror .CodeMirror-code .cm-header-1{font-size:200%;line-height:200%}.CodeMirror .CodeMirror-code .cm-header-2{font-size:160%;line-height:160%}.CodeMirror .CodeMirror-code .cm-header-3{font-size:125%;line-height:125%}.CodeMirror .CodeMirror-code .cm-header-4{font-size:110%;line-height:110%}.CodeMirror .CodeMirror-code .cm-comment{background:rgba(0,0,0,.05);font-family:monospace}.CodeMirror .CodeMirror-code .cm-link{color:#7f8c8d}.CodeMirror .CodeMirror-code .cm-url{color:#aab2b3}.CodeMirror .CodeMirror-code .cm-strikethrough{text-decoration:line-through}.CodeMirror .CodeMirror-code .cm-quote{font-style:italic}.CodeMirror .CodeMirror-placeholder{opacity:.5}", ""]);

// exports


/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = __webpack_require__(581);
var getNotes = function (state) { return state.notes; };
var getSelectedNoteId = function (state) { return state.selectedNote.id; };
var getSearchTerm = function (state) { return state.search.term; };
var hasUpperCase = function (term) { return /[A-Z]/.test(term); };
exports.getSelectedNote = reselect_1.createSelector([getNotes, getSelectedNoteId], function (notes, selectedNote) {
    if (notes.length === 0) {
        return null;
    }
    var noteIndex = notes.findIndex(function (note) { return note.id === selectedNote; });
    if (noteIndex === -1) {
        return notes[0];
    }
    return notes[noteIndex];
});
exports.getFilteredNotes = reselect_1.createSelector([getNotes, getSearchTerm], function (notes, searchTerm) {
    if (!searchTerm || searchTerm.length === 0) {
        return notes;
    }
    var searchCaseSensitive = hasUpperCase(searchTerm);
    return notes.filter(function (note) {
        if (searchCaseSensitive) {
            return note.content.includes(searchTerm);
        }
        return note.content.toLowerCase().includes(searchTerm);
    });
});


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/store/selectors/index.ts"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/store/selectors/index.ts"); } } })();

/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var LandingPage_1 = __webpack_require__(583);
var SignInPage = function () {
    return React.createElement(LandingPage_1.LandingPage, null);
};
exports.default = SignInPage;


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/containers/SignInPage.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/containers/SignInPage.tsx"); } } })();

/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var GoogleSignInButton_1 = __webpack_require__(584);
__webpack_require__(587);
exports.LandingPage = function () {
    return (React.createElement("div", { className: 'landing CodeMirror' },
        React.createElement("div", { className: 'CodeMirror-code' },
            React.createElement("pre", { className: 'CodeMirror-line' },
                React.createElement("span", { className: 'cm-header cm-header-1' },
                    React.createElement("span", { className: 'cm-mod' }, "#"),
                    " Keep your notes simple")),
            React.createElement("pre", { className: 'CodeMirror-line' }, "Light, clean, and free. Write down your thoughts and keep them updated across devices."),
            React.createElement("pre", { className: 'CodeMirror-line' }, "Log in instantly and get started now!"),
            React.createElement("pre", { className: 'CodeMirror-line singInButton' },
                React.createElement(GoogleSignInButton_1.GoogleSignInButton, { loggedIn: false })),
            React.createElement("pre", { className: 'CodeMirror-line' },
                React.createElement("a", { href: 'https://github.com/fawind/notes' }, "GitHub"),
                " |\u00A0",
                React.createElement("a", { href: 'mailto:notes@fabian.me' }, "Contact"),
                " |\u00A0",
                React.createElement("a", { href: 'https://github.com/fawind/notes/issues/new' }, "Help")))));
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/components/LandingPage/index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/components/LandingPage/index.tsx"); } } })();

/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var auth_1 = __webpack_require__(41);
__webpack_require__(585);
exports.GoogleSignInButton = function (props) {
    if (!props.loggedIn) {
        return React.createElement("button", { className: "loginButton", onClick: auth_1.signIn }, "Sign in");
    }
    return React.createElement("button", { className: "loginButton", onClick: auth_1.signOut }, "Sign out");
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/components/GoogleSignInButton/index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/components/GoogleSignInButton/index.tsx"); } } })();

/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(586);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(18)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!./styles.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!./styles.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(17)(undefined);
// imports


// module
exports.push([module.i, ".loginButton{box-sizing:border-box;position:relative;margin:.2em;padding:0 10px 0 46px;line-height:40px;white-space:nowrap;border:none;border-radius:3px;font-size:1rem;font-weight:700;color:#757575;background:#fff;cursor:pointer;box-shadow:0 2px 4px 0 rgba(0,0,0,.25)}.loginButton:before{content:\"\";box-sizing:border-box;position:absolute;top:0;left:0;width:40px;height:100%;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QkEEzgfF0k7hgAAAB1pVFh0Q29tbWVudAAAAAAAQ3JlYXRlZCB3aXRoIEdJTVBkLmUHAAAFKklEQVR42u3aX2xTVRzA8e/t7vp3W1mH2wKBYWADNpnAkKFTMcYY1Pgn49+QhCkIQ0Q0mqC+qKgPGkMiEEKm8WUMCQ+gEkQJEQkKGgwDOvaHsjlEyP7AaCkt63pv7/VhER+2suF6WzrP7/Ge019//fT+OefcI+m6riNiyGESBAJMgAkwASbARAgwASbABJgAEyHABJgAE2ACTICJEGACLDEhJ7oArauD8O+/oTTVo7Z40H1etOt+MEmYMrMwubJIyc7FXFKKefb9SJlZCa1XStRLkN7DBwnt24Nyuo6hliBJEvKUIuwVyzCXPfL/AFPqjhOo3oza6hlWntSCqThWvUrq9FkjFExRCHy+mZ6vd8WueEnCvnQ59spVIEkjB0y/7ufaO+tQmhsNyW8pm0vGhk9Hxk1f93nxrX8F9Y8WY/5xixXbs4tGyCWpqvjeXI3S4DYMy/nhRlJn3jcyhhWBrRuHjJU6uRBzaRnylCJMmS7QdTSfF9XTRPj4MZTG+oRjGXqGKe6T+N6oGhyqqJi0qteQC6fd+mRtrCdQvQmlwZ0wLOPAdA3vqgrUtvO37GZf8gKO5S8P/QmnRQh+uQ1zSWlCsAwD07v307N9OcEfxoE6MIZ98TIcK9eKuSSA3l6LedpVMio9mEb19mu3PT0/KbGMOcPUa0R+GYceCfXhhVII7huPcs7Z9w+lZ+Cq/RbJ4RCrFQB61+6bWACSNULagjZsc9vBBLaFS5MWy5Bhhe47OuBx6wOdyHdbsJZXDCnPiTZteGeCBDMmmJIALHAmapu5uBistiHlWb+zZ9i1HHjbgWy6wy9Jei9Fv2Gml8T18vEFYz9iij2Yei16mzknrmDepAC7gyLYmwzjMNkZvS3cGVewDJuUBGCWsdEfCNdPxBXMlRZ7sJg/JaW0e9Cvnxyw7ZzvL8arIWyyddA8ZQWDl3bZr+PpiAzYlmKScNqTYBwmjSqD9u39jtf05FPdncfqc/t5cWr5oHk+WGAZtE/1oXBUsBynhBGL1jG/JKXs+WD698cGNZn1/tlsC05F06G2eS9B5cawvyeiwZHmSNT22RNTkmTyLTtRXfMAaIlkUOmby8/h3JvN/nCALe4dw/6a706pdPiizwZKJyULGKDkLOb70Dhe8j3MJa3/vHF3ywG2uGv/c/7WLo3qH8NR262pEjPykgjMkVPOV/Jz9OrR09c0fcNW9w50bm9w2XBR462dIUJK9M89UyKTaoyXcUvUdZcbqTr07qD9ikdP5vXplUzLKrhlvwuBdmqb93KoXkbvWAj6wCJpVonaNXbSrUkGBvDxiS/Y3XJgSH0LXZN4cMxMilz5uKxOwprCpUAnFwOdNF1t5Wh7HZred89KCeVj71yLpI7ql2flo2Yq5qQaNrYzFEzVVKp+eg/3lbOxL1x1Yutag9wz5eax6XkpfLLEGvMViriBAXh7/aw5vIEW35+G3IIt3Yuw+J4gb7SJLZU2HBYMjbhsFfCHA6w78hEN3ca8/Z4kz+Ozx1aQ4zR+f0XcNqMomsqm0zXs8uyPad6Hxszi/dK1ZJjT4jI/jft2p+OdbjadrsHjPT+sPJlWJysK57M4/8m4TugTsqFOR+fghWPsaT1I3eUGbqeEXMddPF/wFOUTH8eSYo536YnbgfhPdNy4wq8dpzjT7eGstw1vrx9/ONC3PGNxkmnNINuWxczsIubk3suE9LGJLDfxYMkWYhe1ABNgAkyACTARAkyACTABJsBECDABJsAEmAATYCIEmABLUPwNR2DvzxWZlBQAAAAASUVORK5CYII=) no-repeat;background-size:100%}.loginButton:active{box-shadow:inset 0 0 0 32px rgba(0,0,0,.1)}.loginButton:hover{opacity:.9}", ""]);

// exports


/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(588);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(18)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!./styles.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!./styles.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(17)(undefined);
// imports


// module
exports.push([module.i, ".landing{margin-top:10%}.landing .CodeMirror-line{text-align:center;word-wrap:break-word;white-space:pre-wrap;word-break:normal}.landing .singInButton{margin:15px}.landing a,.landing a:visited{color:red}", ""]);

// exports


/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
__webpack_require__(590);
exports.LoadingBar = function () {
    return React.createElement("div", { className: 'loadingBar' });
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/components/LoadingBar/index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/components/LoadingBar/index.tsx"); } } })();

/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(591);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(18)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(17)(undefined);
// imports


// module
exports.push([module.i, ".loadingBar{height:4px;width:100%;position:fixed;top:0;overflow:hidden;z-index:1}.loadingBar:before{display:block;position:relative;content:\"\";left:-200px;width:200px;height:3px;background-color:red;animation:loading 4s linear infinite}@keyframes loading{0%{left:-60%;width:30%}50%{width:30%}70%{width:70%}80%{left:50%}95%{left:120%}to{left:100%}}", ""]);

// exports


/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(38);
var ErrorActions = __webpack_require__(42);
var ErrorNotification_1 = __webpack_require__(593);
var ErrorNotifier = function (props) {
    if (!props.hasError) {
        return null;
    }
    return React.createElement(ErrorNotification_1.ErrorNotification, { message: props.errorMessage, hideError: props.hideError });
};
var mapStateToProps = function (state) { return ({
    loggedIn: state.account.loggedIn,
    loading: state.loading,
    hasError: state.error.visible,
    errorMessage: state.error.message,
}); };
var mapDispatchToProps = function (dispatch) { return ({
    hideError: function () { return dispatch(ErrorActions.HideError.create()); },
}); };
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ErrorNotifier);


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/containers/ErrorNotifier.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/containers/ErrorNotifier.tsx"); } } })();

/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
__webpack_require__(594);
exports.ErrorNotification = function (props) {
    return (React.createElement("div", { className: 'errorContainer', onClick: props.hideError }, props.message || 'Oops, something went wrong!'));
};


 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } if (typeof module.exports === 'function') { __REACT_HOT_LOADER__.register(module.exports, 'module.exports', "/home/fabian/workspace/notes/app/src/components/ErrorNotification/index.tsx"); return; } for (var key in module.exports) { if (!Object.prototype.hasOwnProperty.call(module.exports, key)) { continue; } var namedExport = void 0; try { namedExport = module.exports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/home/fabian/workspace/notes/app/src/components/ErrorNotification/index.tsx"); } } })();

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(595);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(18)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!./styles.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!./styles.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(17)(undefined);
// imports


// module
exports.push([module.i, ".errorContainer{position:fixed;top:10px;right:10px;max-width:350px;background-color:#fff;border:3px solid red;border-radius:5px;text-align:center;padding:10px;cursor:pointer;z-index:99;box-shadow:0 3px 6px rgba(0,0,0,.16),0 3px 6px rgba(0,0,0,.23)}", ""]);

// exports


/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(597);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(18)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js!./main.css", function() {
			var newContent = require("!!../node_modules/css-loader/index.js!./main.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(17)(undefined);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Nunito);", ""]);

// module
exports.push([module.i, "body,html{margin:0;padding:0;font-family:Nunito,sans-serif;background-color:#fbfbfb;color:#444}.SplitPane .Resizer.vertical{min-width:1px;background-color:#ddd;cursor:col-resize}.SplitPane .Pane.vertical.Pane1{overflow-y:scroll}.SplitPane .Pane1::-webkit-scrollbar{display:none}.icon{position:relative;width:24px;top:6px}", ""]);

// exports


/***/ })

},[120]);


// WEBPACK FOOTER //
// app.868504180f9c99543028.js